import styled from "styled-components";
import { device, zIndex } from "@/style/constants";
import { pxToRem } from "@/style/utils";

export const ModalContainer = styled.div`
  position: relative;
  z-index: ${zIndex.modalLevel};
  .overlay {
    display: none;
  }
  .modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.color_modal_mobile_background};
    text-align: center;
  }

  @media ${device.laptop} {
    .overlay {
      display: block;
      position: fixed;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
      background-color: ${({ theme }) => theme.color_bg_tertiary};
      opacity: 0.9;
    }
    .modal {
      left: 32vw;
      top: 30%;
      width: 504px;
      height: 48vh;
      border-radius: ${pxToRem(8)};
      min-width: ${pxToRem(380)};
      min-height: ${pxToRem(350)};
      background: ${({ theme }) => theme.color_modal_background};
      text-align: center;

      &--product-modal {
        top: 20%;
        height: fit-content;
        width: ${pxToRem(633)};
      }

      &--item-listing-modal {
        height: fit-content;
        width: fit-content;
      }
    }
  }
`;
